"use client"
import { useState } from "react";

export const useForm = (initialState = {}, fieldValidations = {}) => {
   const [inputValues, setInputValues] = useState(initialState);
   const [fieldErrors, setFieldErrors] = useState({});

   const handleInputOnChange = ({ target }, active = null) => {
      const { name, value } = target;
      const maxLength = fieldValidations[name]?.maxLength;
      const message = fieldValidations[name]?.message;

      if (fieldValidations[name]?.required && value.trim() === '') {
         setFieldErrors({
            ...fieldErrors,
            [name]: "* Este campo es requerido"
         });
      } else if (value.length >= 0 && value.length < maxLength) {
         setFieldErrors({
            ...fieldErrors,
            [name]: message
         });
      } else {
         setFieldErrors({
            ...fieldErrors,
            [name]: ""
         });
      }

      const stopInput = maxLength ? value.substring(0, maxLength) : value;

      setInputValues({
         ...inputValues,
         [name]: stopInput
      });

      if (active) {
         setInputValues({
            ...inputValues,
            [target.name]:target.value
         })
      }
   };

   const cleanForm = () => {
      setInputValues(initialState);
   };

   const handleNewValues = (values) => {
      setInputValues({
         ...values
      });
   };


   return { inputValues, fieldErrors, handleInputOnChange, cleanForm, handleNewValues, setFieldErrors };
};
